// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBvdbBJP3CGrPGcMc5yBi4UuR7ch_x3Oc",
  authDomain: "rahimahair-001.firebaseapp.com",
  projectId: "rahimahair-001",
  storageBucket: "rahimahair-001.appspot.com",
  messagingSenderId: "687168029411",
  appId: "1:687168029411:web:4eb0d8664b79f1b811bbd6",
  measurementId: "G-TNW4ZMNC4L",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const signupUser = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};
export const auth = getAuth(app);



